import { useState, useEffect } from 'react';

interface GeneratingDotsProps {
  count: number;
  intervalMs?: number;
}

export function GeneratingDots({ count, intervalMs = 8000 }: GeneratingDotsProps) {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % count);
    }, intervalMs);
    return () => clearInterval(interval);
  }, [count, intervalMs]);

  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`h-1.5 rounded-full transition-all duration-300 ${
            index === currentStep
              ? 'w-6 bg-[#290BD9]'
              : 'w-1.5 bg-gray-300'
          }`}
        />
      ))}
    </div>
  );
}
